<template>
    <div class="tw-w-full">
        <v-dialog transition="fade-transition" max-width="600" v-model="dialog" v-if="postVisible">
            <template v-slot:activator="{ on, attrs }">
                <a v-ripple class="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-text-black" v-if="media.type == 'image'" v-bind="attrs" v-on="on">
                    <v-img height="auto" width="100%" max-height="100%" :aspect-ratio="1/1" :src="media.media" class="tw-rounded tw-border tw-border-solid tw-border-white tw-border-opacity-10 tw-flex tw-items-center tw-justify-center">
                        <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center" >
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-row>
                        </template>
                    </v-img>
                </a>
                <a v-ripple class="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-text-black" v-else v-bind="attrs" v-on="on">
                    <v-img height="auto" width="100%" max-height="100%" :aspect-ratio="1/1" :src="thumb" gradient="to top right, #00000059, #00000059" class="tw-rounded tw-border tw-border-solid tw-border-white tw-border-opacity-10 tw-flex tw-items-center tw-justify-center">
                        <div class="tw-w-full tw-flex tw-items-center tw-justify-center">
                            <div class="tw-w-12 tw-h-12 tw-flex tw-items-center tw-justify-center tw-bg-transparent tw-border tw-border-white tw-rounded-full tw-transform tw-transition-all tw-duration-200 hover:tw-scale-110">
                                <i class="fas fa-play tw-absolute tw-text-white"></i>
                            </div>
                        </div>
                        <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center" >
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-row>
                        </template>
                    </v-img>
                </a>
            </template>
            <template v-slot:default="dialog">
                <v-card class="tw-relative">
                    <div class="tw-absolute tw-top-0 tw-right-0 tw-p-5 tw-z-10  tw-transform tw-scale-75">
                        <inertia-link :href="`/artist/${artist.artista_url}/backstage/${post.id}`" @click="dialog = false" v-ripple class="tw-font-sans tw-text-white tw-bg-black tw-bg-opacity-40 tw-text-xs tw-py-2 tw-px-4 tw-rounded-full tw-tracking-widest">Ir para Post</inertia-link>
                    </div>
                    <v-img :src="media.media" width="100%" height="auto" max-height="750" contain alt="" v-if="media.type == 'image'"/>
                    <vue-plyr :options="options" v-else ref="plyr">
                        <video controls crossorigin playsinline :data-poster="thumb">
                            <source size="1080" :src="media.media" type="video/mp4" />
                        </video>
                    </vue-plyr>
                </v-card>
            </template>
        </v-dialog>
        <inertia-link :href="tenant ? `/backstage/${post.id}` : `/artist/${artist.artista_url}/backstage/${post.id}`" v-ripple class="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-text-black" v-else>
            <v-img height="auto" width="100%" max-height="100%" :aspect-ratio="1/1" class="tw-rounded tw-border tw-border-solid tw-border-white tw-border-opacity-10 tw-flex tw-items-center tw-justify-center">
                <div class="tw-w-full tw-flex tw-items-center tw-justify-center">
                    <i class="fas fa-lock tw-text-white tw-text-2xl tw-opacity-30 tw-mb-2"></i>
                </div>
            </v-img>
        </inertia-link>
    </div>
</template>

<script>
import captureFrame from 'capture-frame';
import {mapState, mapActions} from 'vuex';

export default {
    props: ['media', 'artist', 'post', 'subscriber'],
    data(){
        return {
            thumb: '',
            dialog: false,
            options: {
                controls: [
                    'play-large', // The large play button in the center
                    'play', // Play/pause playback
                    'progress', // The progress bar and scrubber for playback and buffering
                    'duration', // The full duration of the media
                    'mute', // Toggle mute
                    'volume', // Volume control
                    'settings', // Settings menu
                    'fullscreen', // Toggle fullscreen
                ]
            },
        }
    },
    computed: {
        ...mapState('followstatus', ['following']),
        postVisible(){
            if(this.artista_id == this.artist.artista_id){
                return true;
            }
            switch (this.post.visibility) {
                case 'public':
                    return true;
                    break;
                
                case 'follower':
                    return this.following;

                case 'subscriber': 
                    return this.subscriber;
                
                case 'buyer': 
                    return false;

                default:
                    return true;
                    break;
            }
        },
    },
    methods: {
        createThumb(){
            if(this.media.type == 'video'){
                const vm = this;
                const video = document.createElement('video')
                video.addEventListener('canplay', onCanPlay)

                video.volume = 0
                video.autoplay = true
                video.muted = true // most browsers block autoplay unless muted
                video.setAttribute('crossOrigin', 'anonymous') // optional, when cross-domain
                video.src = this.media.media;

                function onCanPlay () {
                    video.removeEventListener('canplay', onCanPlay)
                    video.addEventListener('seeked', onSeeked)

                    video.currentTime = 2 // seek 2 seconds into the video
                }

                function onSeeked () {
                    video.removeEventListener('seeked', onSeeked)

                    const frame = captureFrame(video)

                    // unload video element, to prevent memory leaks
                    video.pause()
                    video.src = ''
                    video.load()
                    vm.thumb = window.URL.createObjectURL(new window.Blob([frame.image]));
                    return;
                }
            } 
        }
    },
    mounted(){
        this.createThumb();
    },
    watch: {
        dialog(newVal, oldVal){
            if(newVal == false && this.media.type == 'video'){
                this.$refs.plyr.player.pause();
            }
        }
    }
}
</script>

<style>
:root {
  --plyr-color-main: #4f1087;
}
</style>